export const convertRangesArrayToObject = (ranges: {start: number, end: number}[]): Record<string, object> => {
	return ranges.reduce((result, range) => {
		const key = `${range.start}-${range.end}`;
		result[key] = {};
		return result;
	}, {} as Record<string, object>);
}

